import { render, staticRenderFns } from "./ProjectVideoTopBarControls.vue?vue&type=template&id=79277e46"
import script from "./ProjectVideoTopBarControls.vue?vue&type=script&lang=js"
export * from "./ProjectVideoTopBarControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports